<template>
   <div class="wrapper">
		 <notify @closeNotice='closeNotice' :shouldNoticeShow='shouldNoticeShow' :title='noticeTitle' :content='noticeContent'></notify>
				<div style='position:relative'>
					<img src="../assets/mainTitle.png" mode="aspectFit" id='mainTitle' />
					<img src="../assets/subTitle.png" mode="aspectFit" id='subTitle' />
					<div class='search-inner-area' @click="toSearch">
						<img src='../assets/icon_search.png' class="search-icon">
						</img>
						<div class="search-txt-area">      搜索规格名称、尺寸    
						</div>
					</div>
					<div id='hot-spec-container'>
							<img v-for="item in hotSearchImg" :src="item.url" class='spec-img' :data-id='item.spec_id' :data-name='item.spec_name'  @click='toSpec' />
					</div>
					<!-- <div class='foot'>
						<div><a href="http://www.id-photo-verify.com" target="_blank">本服务由「证件照研究院」提供</a></div>
					</div> -->
				</div>
				<mt-tabbar v-model="selected" :fixed='true'>
				  <mt-tab-item id="home">
					<img slot="icon" src="../assets/index2.png">
					首页
				  </mt-tab-item>
				  <mt-tab-item id="orderList">
					<img slot="icon" src="../assets/mask2.png">
					订单
				  </mt-tab-item>
				  <mt-tab-item id="customerService">
					<img slot="icon" src="../assets/order.png">
					客服
				  </mt-tab-item>
				</mt-tabbar>
    </div>
</template>

<script>
import notify from "@/components/notify";
import { mapMutations, mapActions, mapState } from "vuex";
import {getOpenId,getMainNotify,getSpecPic } from "@/data/api";
import { config } from "@/config/config";
import { hideMenu } from "@/utils/alipay";

export default {
	components: {
		notify
	},
  data() {
    return {
			shouldNoticeShow:false,
			noticeTitle:'',
			noticeContent:'',
			hotSearchImg:'',
			selected:'home'
		};
  },
  created() {
    ap.setNavigationBar({
      title:' ',
      backgroundColor:'#3B47C4',
    });
		this.$ba.trackPageview("/index");
    this.getAuth();
  },
  beforeMount() {
    this.initConfig();
  },
	beforeDestroy() {
	  ap.setNavigationBar({
	    backgroundColor:'#ffffff',
	  });
	},
  computed: {
    ...mapState(["openId", "serviceTelNumber"])
  },
  methods: {
    ...mapMutations([
      "RECORD_USERINFO",
      "RECORD_LAST_SEARCH",
      "RECORD_SEARCH_RESULTS",
			"RECORD_SPECINFO"
    ]),
    ...mapActions(["getUserInfo", "getPrice","getPrintPrice"]),

    initConfig() {
      this.getPrice().then(() => {
        ap.hideLoading();
      })
      this.getPrintPrice().then(() => {
        ap.hideLoading();
      })
			getMainNotify().then((res)=>{
				if(res.data.code==200){
					if(res.data.is_show==1){
						this.shouldNoticeShow=true;
						this.noticeTitle=res.data.popup_title;
						this.noticeContent=res.data.popup_msg;
					}
				}
			})
			getSpecPic().then((res)=>{
				if(res.status==200){
					console.log(res)
					this.hotSearchImg=res.data["乐骐证件照"];
				}
			})
    },
    getAuth() {
      // first check local storage if exsit store into vuex
      // second check router query if exsit store into local and vuex,
      // if all not exist , go to auth
      // localStorage.removeItem("openId");
      const openId = localStorage.openId || this.$route.query.openId;
      if (openId) {
        this.RECORD_USERINFO(openId);
      } else {
        window.location = config.oAuthUrl;
      }
    },

    toSearch() {
      this.RECORD_LAST_SEARCH(null);
      this.RECORD_SEARCH_RESULTS(null);
      this.$router.push({ name: "search" });
    },
		toSpec(e) {
			let specInfo={
				specId:e.target.dataset.id,
				specName:e.target.dataset.name
			}
			
			this.RECORD_SPECINFO(specInfo);
		  this.$router.push({ name: "spec" });
		},
		closeNotice(){
			this.shouldNoticeShow=false;
		},
  },
	watch:{
		selected:function(val,oldVal){
				switch(val){
						case 'home':
								this.$router.replace('/home');
						break;
						case 'orderList':
								this.$router.replace({ name: "orderList", query: { openId: this.openId } });
						break;
						case 'customerService':
								this.$router.replace('/customerService');
						break;
				}
		}
	}
};
</script>

<style scoped>
#mainTitle{
  width: 100vw;
  height: 42.666vw;
}
#subTitle{
  width: 85.867vw;
  height: 12px;
  margin: 12px 26px;
}
.search-inner-area{
  margin-top: 6px;
  margin-left: 20px;
  display:flex;
  align-items: center;
  width: 89.8333vw;
  height: 44px;
  border-radius:8px;
  background:rgba(255,255,255,1);
  box-shadow:0px 5px 20px 0px rgba(214,214,214,0.5);
}
.cancel{
  width: 30px;
  height: 21px;
  color: #FFF;
  font-size: 15px;
  position: relative;
  left: 5px;
}
.search-icon{
  height: 16px;
  width: 16px;
  margin: 14px 0 14px 15px;
  display: inline-block;
}
.search-txt-area{
  display: inline-block;
  margin: 11.5px 0 11.5px 10px;
  background: #FFF;
  font-size: 15px;
  line-height: 22px;
  height: 22px;
  color: #959494;
}
#title-container{
  margin-top: 18px;
  padding-left: 20px;
  padding-right: 20px;
}
#tutorial{
  float: right;
  display: inline-block;
  margin-top: 5px;
  font-size:12px;
  color:rgba(153,153,153,1);
}
.bottom-search-area{
  height:100px;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 16px 0px rgba(211,211,211,0.5);
  position: fixed;
  bottom: 0;
  padding:15px 15px 0 15px; 
}
.bottom-search-inner-area{
  width: 345px;
  height: 38px;
  border-radius:22.5px;
  background:rgba(245,245,245,1);
  display: flex;
  margin-top: 10px;
}
.bottom-search-txt-area{
  display: inline-block;
  margin: 8px 0 8px 10px;
  background: rgba(245,245,245,1);
  font-size: 13px;
  line-height: 22px;
  height: 22px;
  color: rgba(153,153,153,1);
}
.bottom-txt{
  color:rgba(153,153,153,1);
  font-size:14px;
}
#hot-spec-container img{
  width: 28.8vw;
  height: 25.33vw;
  margin: auto;
}
#hot-spec-container{
  margin:15px 20px 0 20px;
  padding-top: 9px;
  padding-bottom: 9px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 41px 0px rgba(0,0,0,0.1);
  border-radius:8px;
}
.foot{
  text-align: center;
  font-size:12px;
  color:rgba(164,164,164,1);
  padding-top: 18px;
  padding-bottom: 60px;
}
</style>
